//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp3Menu', {
//        templateUrl: 'views/components/views/prodGrp3Menu/prodGrp3Menu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prodGrp3MenuService', 'ttGridFactory', function ($stateParams, stateService, prodGrp3MenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrp3Id = $stateParams.prodgrp3_id;

//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_prodgrp3menu_prodgrp4_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'prodgrp3menu_new',
//                    text: 'prodgrp3menu_new',
//                    func: () => {
//                        stateService.go('prodgrp4', {
//                    	    prodgrp3_id: vm.model.menu.prodgrp3_id,
//                    	    prodgrp4_id: '+'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await prodGrp3MenuService.getMenu({ prodgrp3_id: prodGrp3Id }))[0];

//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3079,
//                    parameters: { prodgrp3_id: vm.model.menu.prodgrp3_id }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
